import React, { useState } from 'react';
import Viewer from 'react-viewer';

function ImgViewer({ height, path, src }) {
	const [visible, setVisible] = useState(false);
	return (
		<>
			<img
				style={{ cursor: 'pointer' }}
				onClick={() => {
					setVisible(true);
				}}
				height={height}
				src={path}
				alt='view_img'
			/>

			<Viewer
				noToolbar
				visible={visible}
				onClose={() => {
					setVisible(false);
				}}
				images={[
					{
						src: src || path.replace('.png', '.jpg'),
						alt: 'view_img',
					},
				]}
			/>
		</>
	);
}

export default ImgViewer;
